import { createStore } from 'vuex'
import AuthModule from './auth.module';
import EmployerModule from './employer.module';
import GeneralModule from './general.module';
import EmployeeModule from './employee.module';

export default createStore({
  modules: {
    AuthModule,
    EmployerModule,
    GeneralModule,
    EmployeeModule,
  }
})
